// Material Dashboard 2 PRO React components
import { Tooltip } from '@mui/material';
import { MDTypography } from '../MDTypography';
import React from 'react';
import { isNullOrEmpty } from '../../../Model/helpers';

interface IDefaultCellProps {
  value: string;
  suffix?: string | boolean;
  tooltip?: boolean;
  maxWidth?: string;
  tooltipValue?: string;
  backgroundColour?: string;
  restrictionValue?: boolean;
  emptyValueText?: string;
}

export function DefaultCell({
  value,
  suffix = '',
  tooltip = false,
  maxWidth = "150px",
  tooltipValue,
  backgroundColour,
  restrictionValue = false,
  emptyValueText,
}: IDefaultCellProps) {

  const showEmptyValueText = isNullOrEmpty(value) && emptyValueText;  
  if (showEmptyValueText) {
    value = emptyValueText;
  }

  if (tooltip && !showEmptyValueText) {
    return (
      <Tooltip 
        className="text-overflow" 
        title={value?.length > 600 ? value.substring(0, 600) + "..." : value || "..."} 
        componentsProps={{
          tooltip: {
            sx: {
              maxWidth: '300px',
            },
          },
        }}
      >
        <MDTypography variant='caption' fontWeight='regular' color='text' backgroundColor={backgroundColour} style={{ maxWidth: maxWidth}}>
          {tooltipValue !== undefined ? tooltipValue : value}
          {suffix && (
            <MDTypography variant='caption' fontWeight='regular' color='secondary'>
              &nbsp;&nbsp;{suffix}
            </MDTypography>
          )} 
        </MDTypography>
      </Tooltip>
    )
  }
  else {
    return (
      <MDTypography variant='caption' fontWeight='regular' color={restrictionValue ? 'error' : 'text'} backgroundColor={backgroundColour} style={{ fontStyle: restrictionValue || showEmptyValueText ? 'italic' : 'normal', opacity: showEmptyValueText ? 0.5 : 1 }} >
        {value}
        {suffix && (
          <MDTypography variant='caption' fontWeight='regular' color='secondary'>
            &nbsp;&nbsp;{suffix}
          </MDTypography>
        )}
      </ MDTypography>
    );
  }

}
